import { TranslateService } from '@ngx-translate/core';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import { CurrentUserService } from '../current-user.service';
import { NbToastrService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { alert } from 'devextreme/ui/dialog';


@Component({
  selector: 'ngx-user-language',
  templateUrl: './user-language.component.html',
  styleUrls: ['./user-language.component.scss']
})
export class UserLanguageComponent implements OnInit, OnDestroy {
  @ViewChild(DxFormComponent) form: DxFormComponent
  popupVisible: boolean = false;
  errorMessages: string[];
  loadingVisible = false;
  selectedLanguage: any;

  languages: any[];
  localizedMessages: string[];
  subscription: Subscription;

  constructor(private _translateService: TranslateService, private _currentUserService: CurrentUserService, private _toastrService: NbToastrService,) {
    this.languages = [
      { id: 'nl', name: 'Nederlands' },
      { id: 'en', name: 'English' },
      { id: 'de', name: 'Deutsch' },
    ]
  }

  ngOnInit(): void {
    this.selectedLanguage = this._translateService.currentLang;

    this.subscription = this._currentUserService.onShowChooseLanguage().subscribe((data) => {
      this.show();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  show() {
    this.popupVisible = true;
  }

  hide() {
    this.popupVisible = false;

  }

  passwordComparison = () => {
    return this.form.instance.option("formData").NewPassword;
  }

  onFormSubmit() {
    if (!!this.selectedLanguage) {
      this.loadingVisible = true;
      this._currentUserService.setUserPreferredLanguage(this.selectedLanguage).subscribe(
        {
          next: (data) => {
            this._translateService.use(this.selectedLanguage);
            this.loadingVisible = false;
            this.popupVisible = false;
            this._currentUserService.languageChange();
            this._toastrService.success(this._translateService.instant('ALGEMEEN.TAAL_GEWIJZIGD'), this._translateService.instant('ALGEMEEN.GELUKT'));
          },
          error(err) {
            this._toastrService.danger(this._translateService.instant('ALGEMEEN.TAAL_NIET_GEWIJZIGD'), this._translateService.instant('ALGEMEEN.FOUT.TITEL'));
          },
          complete() {
            this.loadingVisible = false;
          },
        }
      );
    } else {
      alert(this._translateService.instant('ALGEMEEN.TAALKEUZE_VERPLICHT'), this._translateService.instant('ALGEMEEN.LETOP'));
    }
  }

  onValueChanged(event) {
    if (event.value != event.previousValue) {
      //this._translateService.use(event.value);
    }
  }

}
